export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6047.20451dd7.jpg";